import React, { Component } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Container } from 'react-bootstrap';

export class Layout extends Component {
  static displayName = Layout.name;
  render() {
    return (
      <div>
        <Header />
        <div className='page-content blue-bg'>
          <Container>
            {this.props.children}
          </Container>
        </div>
        <Footer />
      </div >
    );
  }
}